  document.addEventListener('DOMContentLoaded', () => {
    // ★ Add to Cart 本体フォームをIDでピン留め（インストールメント等を除外）
    const formId = '{{ product_form_id }}';
    const form = document.getElementById(formId);

    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) {
      console.warn(
        '[survey] Add to Cart フォームが見つかりません。id=',
        formId,
        'action=',
        form && form.getAttribute('action')
      );
      return;
    }

    // ★ 対象商品のみモーダルが存在（タグでLiquid側が描画済み）
    const modal = document.querySelector(`#survey-modal-{{ section.id }}`);
    if (!modal) return;

    // ========= モーダル開閉 =========
    const openModal = () => {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.querySelector('.survey-modal__panel')?.focus();
      document.body.style.overflow = 'hidden';
    };
    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    modal.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeModal));
    modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('survey-modal__backdrop')) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });

    // ========= Add to Cart を横取り（未回答ならモーダルへ） =========
    form.addEventListener(
      'submit',
      (e) => {
        if (form.dataset.surveyDone === '1') return; // 2回目以降は素通し
        // ※「今すぐ購入」は素通しにしたい場合は以下のコメントアウトを外す
        // const submitter = e.submitter || document.activeElement;
        // if (submitter && submitter.getAttribute('name') === 'buy_it_now') return;

        e.preventDefault();
        e.stopPropagation();
        openModal();
      },
      { capture: true }
    );

    // ========= アンケート送信処理 =========
    const surveyForm = modal.querySelector('.survey-form');

    // 値がある項目だけ hidden を生成・更新。空なら hidden を削除して送らない。
    const upsertHidden = (propLabel, value) => {
      const name = `properties[${propLabel} ]`;
      let input = form.querySelector(`input[name="${name}"]`);
      if (value && value.length) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input); // 必ず Add to Cart の本体フォーム内へ
        }
        input.value = value;
      } else {
        if (input) input.remove();
      }
    };

    surveyForm.addEventListener('submit', (e) => {
      e.preventDefault();

      // エラースタイル初期化
      surveyForm.querySelectorAll('.survey-item').forEach((fs) => {
        fs.classList.remove('survey-item--error');
        fs.querySelector('.survey-error')?.setAttribute('hidden', 'hidden');
      });

      let ok = true;

      // 全アンケート項目を収集
      surveyForm.querySelectorAll('.survey-item').forEach((fs) => {
        const prop = fs.dataset.prop; // 主な使用目的 / 導入時期 / 現在使用ソフト / 3Dスキャナー保有 / XNurbs頻度
        const required = fs.dataset.required === 'true';
        const multiple = fs.dataset.multiple === 'true';

        let vals = [];
        if (multiple) {
          vals = Array.from(fs.querySelectorAll('input[type="checkbox"]:checked')).map((i) => i.value);
        } else {
          const picked = fs.querySelector('input[type="radio"]:checked');
          if (picked) vals = [picked.value];
        }

        if (required && vals.length === 0) {
          ok = false;
          fs.classList.add('survey-item--error');
          fs.querySelector('.survey-error')?.removeAttribute('hidden');
        }

        // ★ 回答がある項目だけ hidden を作成（空のプロパティは送らない）
        upsertHidden(prop, vals.join('、'));
      });

      if (!ok) {
        surveyForm.querySelector('.survey-item--error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // 送信
      form.dataset.surveyDone = '1';
      closeModal();

      // DawnのAjax送信にも対応
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  });